(function () {
    // =======================================================
    // GLOBALE KONFIGURATION - Hier anpassen für verschiedene Shops
    // =======================================================
    const GLOBAL_CONFIG = {
        // Debug-Modus
        debugMode: false,
        
        // Microsoft Ads Konfiguration
        microsoftAds: {
            enabled: false, // Service verfügbar machen (nicht automatisch laden!)
            uetTagId: "XYZ", // UET Tag ID (ti:)
            trackingMethod: "shpfy_ui" // Tracking Method (tm:)
        },
        
       // Microsoft Clarity Konfiguration
        microsoftClarity: {
            enabled: true,
            clarityId: "nq7o9uju4u" // Clarity Project ID
        },
        
        // Google Ads Konfiguration
        googleAds: {
            enabled: true,
            conversionId: "AW-16660813599", // Google Ads Conversion ID
            enhancedConversions: true,
            adPersonalizationSignals: true
        },
        
        // Weitere Tracking-Services können hier hinzugefügt werden
        // googleAnalytics: {
        //     enabled: false,
        //     measurementId: "G-XXXXXXXXXX"
        // }
    };

    // WICHTIG: 'enabled: true' bedeutet nur, dass der Service VERFÜGBAR ist.
    // Die Services werden erst geladen, wenn der Nutzer Consent gegeben hat!

    // =======================================================
    // AB HIER NICHTS MEHR ÄNDERN - Automatische Konfiguration
    // =======================================================

    // Debug-Modus aus globaler Konfiguration
    const custom_debugMode = GLOBAL_CONFIG.debugMode;

    // Dynamische Skriptkonfiguration basierend auf globaler Konfiguration
    const custom_scriptConfig = [];

    // Microsoft Ads Tracking hinzufügen (falls aktiviert)
    if (GLOBAL_CONFIG.microsoftAds.enabled) {
        custom_scriptConfig.push({
            type: "marketing",
            name: "Microsoft Ads Tracking",
            customCode: function MsAdsUetqTrackingLazyLoading() {
                if (window.custom_msAdsTrackingInitialized) {
                    custom_log("Microsoft Ads Tracking already initialized. Skipping.");
                    return;
                }

                // Microsoft Ads Tracking-Skript mit dynamischen Parametern
                function MsAdsUetqTracking(){
                    (function(w,d,t,r,u){
                        var f,n,i;
                        w[u]=w[u]||[];
                        f=function(){
                            var o={
                                ti: GLOBAL_CONFIG.microsoftAds.uetTagId,
                                tm: GLOBAL_CONFIG.microsoftAds.trackingMethod,
                                enableAutoSpaTracking: true
                            };
                            o.q=w[u];
                            w[u]=new UET(o);
                            w[u].push("pageLoad");
                        };
                        n=d.createElement(t);
                        n.src=r;
                        n.async=1;
                        n.onload=n.onreadystatechange=function(){
                            var s=this.readyState;
                            (!s||s==="loaded"||s==="complete")&&(f(),n.onload=n.onreadystatechange=null);
                        };
                        i=d.getElementsByTagName(t)[0];
                        i.parentNode.insertBefore(n,i);
                    })(window,document,"script","//bat.bing.com/bat.js","uetq");
                    custom_log("Microsoft Ads Tracking executed.");
                }

                // Custom Event zur Kommunikation dispatchen
                const MSAdsLoadedEvent = new CustomEvent('CustomMSAdsLoaded');
                document.dispatchEvent(MSAdsLoadedEvent);
                custom_log("Custom event 'CustomMSAdsLoaded' dispatched.");

                // Lazy Loading erst bei Nutzerinteraktion
                const events = ["touchstart", "mousemove", "scroll"];
                const MSAdsonInteraction = () => {
                    MsAdsUetqTracking();
                    events.forEach(event => window.removeEventListener(event, MSAdsonInteraction));
                };

                events.forEach(event => window.addEventListener(event, MSAdsonInteraction, { once: true, passive: true }));
                window.custom_msAdsTrackingInitialized = true;
                custom_log("Microsoft Ads Tracking initialized and prepared. Pay attention for the separate executed status.");
            },
            priority: 1
        });
    }

    // Microsoft Clarity Tracking hinzufügen (falls aktiviert)
    if (GLOBAL_CONFIG.microsoftClarity.enabled) {
        custom_scriptConfig.push({
            type: "analytics",
            name: "Microsoft Clarity Tracking",
            customCode: function MsClarityLazyLoading() {
                if (window.custom_msClarityInitialized) {
                    custom_log("Microsoft Clarity Tracking already initialized. Skipping.");
                    return;
                }

                // Microsoft Clarity Tracking-Skript mit dynamischer Clarity ID
                const MsClarityLoadScript = function() {
                    (function(c,l,a,r,i,t,y){
                        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                        t=l.createElement(r);
                        t.async=1;
                        t.src=`https://www.clarity.ms/tag/${GLOBAL_CONFIG.microsoftClarity.clarityId}`;
                        y=l.getElementsByTagName(r)[0];
                        y.parentNode.insertBefore(t,y);
                    })(window,document,"clarity","script",GLOBAL_CONFIG.microsoftClarity.clarityId);
                    window.clarity('consent');
                    custom_log("Microsoft Clarity Tracking executed.");
                };

                // Lazy Loading erst bei Nutzerinteraktion
                const MsClarityLazyLoadEvents = function() {
                    ["scroll", "mousemove", "touchstart"].forEach(evt => 
                        window.removeEventListener(evt, MsClarityLazyLoadEvents)
                    );
                    MsClarityLoadScript();
                };

                ["scroll", "mousemove", "touchstart"].forEach(evt =>
                    window.addEventListener(evt, MsClarityLazyLoadEvents, { passive: true, once: true })
                );

                window.custom_msClarityInitialized = true;
                custom_log("Microsoft Clarity Tracking initialized and prepared. Pay attention for the separate executed status.");
            },
            priority: 2
        });
    }

    // Google Analytics könnte hier hinzugefügt werden
    // if (GLOBAL_CONFIG.googleAnalytics?.enabled) {
    //     custom_scriptConfig.push({
    //         type: "analytics",
    //         name: "Google Analytics",
    //         customCode: function GoogleAnalyticsLazyLoading() {
    //             // Google Analytics Implementierung
    //         },
    //         priority: 3
    //     });
    // }

    // Sets zur Vermeidung mehrfacher Ausführung
    const custom_loadedScripts = new Set();
    const custom_executedCustomCodes = new Set();

    // Vorheriger Consent-Status zur Vergleichszwecken
    let custom_previousConsent = null;
    let custom_googleConsentInitialized = false;
    let custom_microsoftConsentInitialized = false;

    // Konsistentes Logging
    function custom_log(message, data = null, isError = false) {
        if (isError || custom_debugMode) {
            const logMethod = isError ? console.error : console.log;
            logMethod(`[Consent Manager] ${message}`, data);
        }
    }

    // Lade ein Skript oder führe benutzerdefinierten Code aus
    function custom_loadScript({ type, name = "Unnamed Script", url, async = true, defer = false, customCode = null }) {
        if (customCode) {
            if (custom_executedCustomCodes.has(name)) {
                custom_log(`Custom code for script: ${name} (${type}) already executed. Skipping.`);
                return;
            }
            custom_log(`Executing custom code for script: ${name} (${type}).`);
            customCode();
            custom_executedCustomCodes.add(name);
            return;
        }

        if (!url) {
            custom_log(`No URL provided for script: ${name} (${type}).`, null, true);
            return;
        }

        if (custom_loadedScripts.has(url)) {
            custom_log(`Script ${name} (${type}) already loaded. Skipping.`);
            return;
        }

        const script = document.createElement("script");
        script.src = url;
        script.async = async;
        script.defer = defer;
        script.onerror = () => custom_log(`Failed to load script: ${name} (${type}).`, null, true);
        script.onload = () => custom_log(`Script loaded successfully: ${name} (${type}).`);
        document.head.appendChild(script);
        custom_loadedScripts.add(url);
    }

    // Lade alle Skripte eines bestimmten Typs basierend auf Zustimmung
    function custom_loadScriptsByType(type, consentGranted) {
        // WICHTIG: Services werden NUR geladen wenn Consent erteilt wurde
        if (!consentGranted) {
            custom_log(`${type} consent NOT granted. Skipping all ${type} scripts.`);
            return;
        }

        const scriptsToLoad = custom_scriptConfig
            .filter(script => script.type === type)
            .sort((a, b) => a.priority - b.priority);

        if (scriptsToLoad.length === 0) {
            custom_log(`No scripts configured for ${type}.`);
            return;
        }

        custom_log(`Consent GRANTED for ${type}. Loading ${scriptsToLoad.length} ${type} scripts in priority order...`);
        scriptsToLoad.forEach(({ customCode, name, url, async, defer }) => {
            custom_loadScript({ type, name, url, async, defer, customCode });
        });
    }

    // Ermittel den Consent-Status via Shopify Customer Privacy API
    function custom_checkConsent() {
        const consentSource = "Shopify Customer Privacy API";
        
        // Neue Methoden für direkten Zugriff auf boolean-Werte
        const marketingAllowed = window.Shopify?.customerPrivacy?.marketingAllowed?.();
        const analyticsAllowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();

        if (marketingAllowed !== undefined && analyticsAllowed !== undefined) {
            custom_log(`Using consent data from ${consentSource}.`, {
                marketing: marketingAllowed,
                analytics: analyticsAllowed
            });
            processConsent(marketingAllowed, analyticsAllowed);
        } else {
            // Warte auf das Laden der Shopify Consent API
            document.addEventListener('consentTrackingApiLoaded', () => {
                custom_log("Shopify Consent Tracking API now available, checking consent again.");
                const marketingAllowed = window.Shopify?.customerPrivacy?.marketingAllowed?.();
                const analyticsAllowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
                
                if (marketingAllowed !== undefined && analyticsAllowed !== undefined) {
                    custom_log(`Using consent data from ${consentSource} after API loaded.`, {
                        marketing: marketingAllowed,
                        analytics: analyticsAllowed
                    });
                    processConsent(marketingAllowed, analyticsAllowed);
                } else {
                    custom_log("Consent data still not available after API loaded.", null, true);
                }
            }, { once: true });
            custom_log("Waiting for Shopify Consent Tracking API to load...");
        }

        // Verarbeite den erhaltenen Consent-Zustand
        function processConsent(marketingConsent, analyticsConsent) {
            const previousMarketingConsent = custom_previousConsent?.marketingConsent ?? false;
            const previousAnalyticsConsent = custom_previousConsent?.analyticsConsent ?? false;

            const currentConsent = { marketingConsent, analyticsConsent };
            custom_previousConsent = currentConsent;

            custom_log("=== CONSENT STATUS RECEIVED ===");
            custom_log("Marketing Consent:", marketingConsent ? "✅ GRANTED" : "❌ DENIED");
            custom_log("Analytics Consent:", analyticsConsent ? "✅ GRANTED" : "❌ DENIED");
            custom_log("Consent source:", consentSource);

            // Nur Services laden, die auch Consent haben
            custom_loadScriptsByType("marketing", marketingConsent);
            custom_loadScriptsByType("analytics", analyticsConsent);

            const marketingConsentStatus = marketingConsent ? 'granted' : 'denied';
            const analyticsConsentStatus = analyticsConsent ? 'granted' : 'denied';

            // Google Consent Mode verwalten (falls Google Ads aktiviert)
            if (GLOBAL_CONFIG.googleAds.enabled) {
                if (!custom_googleConsentInitialized) {
                    gtag('consent', 'default', {
                        'ad_storage': marketingConsentStatus,
                        'ad_user_data': marketingConsentStatus,
                        'ad_personalization': marketingConsentStatus,
                        'analytics_storage': analyticsConsentStatus,
                        'functionality_storage': 'granted',
                        'personalization_storage': marketingConsentStatus,
                        'security_storage': 'granted',
                        'wait_for_update': 500
                    });

                    custom_log("Google Consent Mode initialized:", {
                        'ad_storage': marketingConsentStatus,
                        'ad_user_data': marketingConsentStatus,
                        'ad_personalization': marketingConsentStatus,
                        'analytics_storage': analyticsConsentStatus,
                        'functionality_storage': 'granted',
                        'personalization_storage': marketingConsentStatus,
                        'security_storage': 'granted'
                    });

                    custom_googleConsentInitialized = true;

                    const googleEvent = new CustomEvent('GoogleDefaultConsentLoaded');
                    document.dispatchEvent(googleEvent);
                    custom_log("Custom event 'GoogleDefaultConsentLoaded' dispatched.");
                } else if (marketingConsent !== previousMarketingConsent || analyticsConsent !== previousAnalyticsConsent) {
                    gtag('consent', 'update', {
                        'ad_storage': marketingConsentStatus,
                        'analytics_storage': analyticsConsentStatus,
                        'ad_user_data': marketingConsentStatus,
                        'ad_personalization': marketingConsentStatus,
                        'personalization_storage': marketingConsentStatus
                    });
                    custom_log("Google Consent Mode updated:", {
                        'ad_storage': marketingConsentStatus,
                        'analytics_storage': analyticsConsentStatus,
                        'ad_user_data': marketingConsentStatus,
                        'ad_personalization': marketingConsentStatus,
                        'personalization_storage': marketingConsentStatus
                    });
                } else {
                    custom_log("No changes detected in Google Consent Mode. Skipping update.");
                }
            }

            // Microsoft Consent aktualisieren (falls Microsoft Ads aktiviert)
            if (GLOBAL_CONFIG.microsoftAds.enabled) {
                if (!custom_microsoftConsentInitialized) {
                    window.uetq = window.uetq || [];
                    window.uetq.push('consent', 'default', {
                        'ad_storage': marketingConsentStatus
                    });

                    custom_log("Microsoft Advertising Default Consent pushed:", {
                        'ad_storage': marketingConsentStatus
                    });

                    custom_microsoftConsentInitialized = true;

                    const microsoftEvent = new CustomEvent('MicrosoftDefaultConsentLoaded');
                    document.dispatchEvent(microsoftEvent);
                    custom_log("Custom event 'MicrosoftDefaultConsentLoaded' dispatched.");
                } else if (marketingConsent !== previousMarketingConsent) {
                    window.uetq = window.uetq || [];
                    window.uetq.push('consent', 'update', {
                        'ad_storage': marketingConsentStatus
                    });

                    custom_log("Microsoft Advertising Consent update pushed:", {
                        'ad_storage': marketingConsentStatus
                    });
                } else {
                    custom_log("No changes detected in Microsoft Advertising Consent. Skipping update.");
                }
            }
        }
    }

    // Listener für Consent-Änderung via Shopify Event
    function custom_addConsentChangeListener() {
        document.addEventListener("visitorConsentCollected", function () {
            custom_log("Consent settings updated via Shopify Customer Privacy API.");
            custom_checkConsent();
        });
    }

    // Initialer Einstiegspunkt
    window.addEventListener("load", function () {
        // Google gtag initialisieren, sobald Consent gesetzt wurde (nur wenn Google Ads aktiviert)
        if (GLOBAL_CONFIG.googleAds.enabled) {
            document.addEventListener('GoogleDefaultConsentLoaded', function gadstagLoader() {
                gtag("js", new Date());
                gtag("config", GLOBAL_CONFIG.googleAds.conversionId, { 
                    "allow_enhanced_conversions": GLOBAL_CONFIG.googleAds.enhancedConversions,
                    "allow_ad_personalization_signals": GLOBAL_CONFIG.googleAds.adPersonalizationSignals
                });
                custom_log("gtag js and gtag-config loaded after fully Consent Mode initialization.");
                const googleGtagLoadedEvent = new CustomEvent('CustomGtagLoaded');
                document.dispatchEvent(googleGtagLoadedEvent);
                custom_log("Custom event 'CustomGtagLoaded' dispatched.");
                document.removeEventListener('GoogleDefaultConsentLoaded', gadstagLoader);
            });
        }

        // Consent initial abfragen und Event-Listener registrieren
        custom_checkConsent();
        custom_addConsentChangeListener();

        const event = new CustomEvent('ConsentManagementCodeLoaded');
        document.dispatchEvent(event);
        custom_log("Custom event 'ConsentManagementCodeLoaded' dispatched.");
    });

    // Globale Konfiguration für Debug-Zwecke verfügbar machen
    if (custom_debugMode) {
        window.CONSENT_MANAGER_CONFIG = GLOBAL_CONFIG;
        custom_log("Global configuration available at window.CONSENT_MANAGER_CONFIG for debugging.");
    }
})();